import { JoinOpenTableScreen } from '@/screens/index'

export default function () {
  return <JoinOpenTableScreen />
}
